import styled from 'styled-components';
import {Link} from 'react-router-dom';

export const Container = styled.div`
min-height: 692px;
position: fixed;
bottom: 0;
left: 0;
right: 0;
top: 0;
z-index: 0;
display: flex; 
flex: 1;
overflow: hidden;
background: linear-gradient(
  108deg,
  rgba(246, 246, 246, 1) 0%,
  rgba(246, 246, 246, 1) 100%
);

justify-content: center;
align-items: center;
`;

export const FormWrap = styled.div`
height: 100%;
width: 100%;
display: flex;
flex-direction: column;
justify-content: center;

@media screen and (max-width: 400px ) {
  height: 80%;
}
`;


export const HeroContent = styled.div`
z-index: 3;
 width: 100%;
 height: 100%;
 position: absolute;
 display: flex;
 justify-content: center;
 flex-direction: column;
 align-items: center;
 background: 
linear-gradient(180deg, rgba(0,0,0,0.3) 0%, rgba(0,0,0,0.1) 100%
), 
linear-gradient(180deg, rgba(0,0,0,0.3) 0%, transparent 100%);
z-index: 2;
  
`;



export const HeroWrapper = styled.div`

 flex-direction: column;
/*  background: 
linear-gradient(180deg, rgba(246, 246, 246, 1) 0%, rgba(246, 246, 246, 0) 100%
), 
linear-gradient(180deg, rgba(229, 29, 29, 0.3) 0%, transparent 100%); */
z-index: 2;

display: flex;
height: 100%;
width: 100%; 
align-Items: center; 
justify-Content: center;
border-Radius: 50px;
flex-Direction: column;
  
`;



export const FormState = styled.div`

 flex-direction: column;
 background: linear-gradient(
  108deg,
  rgba(214, 44, 44, 1) 0%,
  rgba(226, 116, 116, 1) 100%
);
display: flex;
flex: 1;
height: 100%;
width: 100%; 
align-Items: center; 
justify-Content: center;
  
`;

export const InfoWrapper = styled.div`
display: grid;
grid-template-columns: 1.5fr 1fr;
grid-gap: 10px;
z-index: 1;
height: 90%;
width: 80%;
max-width: 100%;
z-index: 2;

margin-left: auto;
margin-right: auto;
padding: 0 0px;
justify-content: center;

 
@media screen and (max-width: 940px) {
  grid-template-columns: 1fr;
  padding: 0 20px;
}
`;


export const InfoContain = styled.div`
width: 100%; 
height: 200px;
flex: 1.5;
display: flex;
align-Items: center;
justify-Content: 'flex-start';
padding-Left: 20px; 
background: linear-gradient(
  360deg,
  rgba(0, 0, 0, 1) 50%,
   transparent 150%);
);
padding: 5 10px;
flex-direction: column;



@media screen and (max-width: 1000px) {
  grid-template-columns: 1fr 1fr;
}
 
@media screen and (max-width: 768px) {
  grid-template-columns: 1fr;
  padding: 0 20px;
}
`;


export const InfoMap = styled.div`
display: grid;
grid-template-columns: 1fr 1fr 1fr;
grid-gap: 10px;
z-index: 1;
height: 100%;
width: 100%;
max-width: 1300px;

margin-left: 20px;
margin-right: 20px;
padding: 0 50px;
justify-content: center;

align-Items: center; 



@media screen and (max-width: 1000px) {
  grid-template-columns: 1fr 1fr;
}
 
@media screen and (max-width: 768px) {
  grid-template-columns: 1fr;
  padding: 0 20px;
}
`;

export const ItemMap = styled.div`
background: linear-gradient(
  108deg,
  rgba(214, 44, 44, 1) 0%,
  rgba(73, 77, 83, 0.8) 100%
);
display: flex;
color: white;
flex: 1; 
width: 100%;
height: 60%;
align-Items: center;
justify-Content: center; 
border-Radius: 40px; 
flex-Direction: column;
transition: all 0.2s ease-in-out;
cursor: pointer;
border: 5px solid;

&:hover {
  
width: 100%;
height: 60%;
transform: translateY(-15px); 
  transition: all 0.3s ease-in-out;
  background: linear-gradient(
    108deg,
    rgba(208, 46, 46, 1) 0%,
  rgba(73, 77, 83, 1) 100%
  );
  color: lightgrey;
}


`;





export const ItemButtom = styled.div`
background: linear-gradient(
  108deg,
  rgba(214, 44, 44, 1) 0%,
  rgba(73, 77, 83, 0.8) 100%
);
display: flex;
color: white;
width: 35px;
height: 35px;
align-Items: center;
justify-Content: center; 
border-Radius: 40px; 
flex-Direction: row;
transition: all 0.2s ease-in-out;
cursor: pointer;
border: 3px solid;
margin-left: 10px;
margin-rigth: 10px;

&:hover {
  
  width: 35px;
height: 35px;
transform: translateY(-5px); 
  transition: all 0.3s ease-in-out;
  background: linear-gradient(
    108deg,
    rgba(208, 46, 46, 1) 0%,
  rgba(73, 77, 83, 1) 100%
  );
  color: lightgrey;
}


`;



export const ItemContain = styled.div`
background: linear-gradient(
  108deg,
  rgba(214, 44, 44, 1) 0%,
  rgba(73, 77, 83, 0.8) 100%
);
display: flex;
flex-Direction: row;
border-Radius: 40px;
margin-Top: 10px;

height: auto;
&:hover {
  
  width: 20%;
  height: 40%;
transform: translateY(-5px); 
  transition: all 0.3s ease-in-out;
  background: linear-gradient(
    108deg,
    rgba(208, 46, 46, 1) 0%,
  rgba(73, 77, 83, 1) 100%
  );
  color: lightgrey;
}


`;


export const Icon = styled(Link)`
align-self: center;
margin-top: 40px;
text-decoration: none;
color: #fff;
font-weight: 700;
font-size: 20px;
transition: all 0.2s ease-in-out;

&:hover{
  transform: scale(1.02);
  transition: all 0.2 ease-in-out;

@media screen and (max-width: 480px) {
  margin-left: 16px;
  margin-top: 8px;
}
`;

export const LogoMC = styled.img`
width: 170px;
height: 35px; 
align-Self: center;
`;

export const ImgBackground = styled.img`
width: 170px;
height: 35px; 
align-Self: center;
`;

export const FormContent = styled.div`
height: 100%;
display: flex;
flex-direction: column;
justify-content: center;


@media screen and (max-width: 480px) {
  padding: 10px;
}
`;

export const ImageWrapper = styled.div`
height: 70px;
display: flex;
width: 100%;
align-Items: center;
justify-Content: center;

@media screen and (max-width: 480px) {
  padding: 10px;
}
`;

export const Form = styled.form`
/* background: 
linear-gradient(180deg, rgba(229, 29, 29, 1) 0%, rgba(229, 29, 29, 0.4) 100%
), 
linear-gradient(180deg, rgba(229, 29, 29,0.3) 0%, transparent 100%); */
z-index: 2;
max-width: 400px;
height: auto;
width: 100%;
z-index: 1;
display: grid;
margin: 0 auto;
margin-bottom: 100px;
padding: 50px 32px;
/* border-radius: 30px;
box-shadow: 0 1px 3px rgba(0, 0, 0, 0.9); */

@media screen and (max-width: 400px) {
  padding: 32px 32px;
}
`;

export const FormH1 = styled.h1`
margin-bottom: 20px;
color: #fff;
font-size: 18px;
font-weight: 400;
text-align: center;
`;

export const FormLabel = styled.label`
margin-bottom: 8px;
font-size: 14px;
color: #fff;
`;

export const FormInput = styled.input`
padding: 16px 16px;
margin-bottom: 32px;
border: none;
border-radius: 4px;
`;

export const FormButton = styled.button`
background: linear-gradient(
  108deg,
  rgba(13, 75, 150, 1) 0%,
  rgba(73, 77, 83, 1) 100%
);
padding: 16px 0;
border: none;
border-radius: 4px;
color: #fff;
font-size: 20px;
cursor: pointer;
`;

export const Text = styled.button`
background: none;
border: none;
cursor: pointer;
text-align: center;
margin-top: 24px;
color: #fff;
font-size: 14px;

`
export const Text2 = styled.button`
display: inline-flex;
-moz-box-align: center;
align-items: center;
-moz-box-pack: center;
justify-content: center;
position: relative;
box-sizing: border-box;
outline: 0px;
border: 0px none;
margin: 0px;
cursor: pointer;
user-select: none;
vertical-align: middle;
appearance: none;
text-decoration: none;
font-family: "Roboto", "Helvetica", "Arial", sans-serif;
font-weight: 500;
font-size: 0.875rem;
line-height: 1.75;
letter-spacing: 0.02857em;
text-transform: uppercase;
min-width: 64px;
padding: 6px 16px;
border-radius: 4px;
transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, border-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
box-shadow: rgba(0, 0, 0, 0.2) 0px 3px 1px -2px, rgba(0, 0, 0, 0.14) 0px 2px 2px 0px, rgba(0, 0, 0, 0.12) 0px 1px 5px 0px;
color: rgb(255, 255, 255);
background-color: rgb(33, 150, 243);

&:hover {
  background-color: rgb(25, 118, 210);
}

`


export const HeroBg = styled.div`
top: 0;
right: 0;
bottom: 0;
left: 0;
width: 100%;
height: 100%;
overflow: hidden;
display: flex;
justify-content: center;
align-Items: center;
background: linear-gradient(180deg, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0.8) 100%),
linear-gradient(180deg, rgba(255, 255, 255, 0.3) 0%, transparent 100%);
`;

export const VideoBg = styled.video`
width: 100%;
 height: 100%;
 -o-object-fit: cover;
 object-fit: cover;
 background: #232a34;
 
 
`;

export const Transparent = styled.div`
background: rgba(0,0,0,1); 
display: flex; 
flex: 1;
align-items: center;
justify-content: center;
`;

export const InfoSlide = styled.div`
display: flex;
flex: 1;
width: 100%;
height: 100%;
align-Items: center;
justify-Content: center;
flex-Direction: column;
background: linear-gradient(180deg, rgba(255,255,255,1) 0%, rgba(255,255,255, 0.6) 100%
), 
linear-gradient(180deg, rgba(255,255,255,0.3) 0%, transparent 100%);
z-index: 2;

@media screen and (max-width: 940px) {
  display: none;
}
`
;